import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';

import {
  Form,
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Alert,
  Badge,
} from 'reactstrap';

import {
  AllSubjectsDashboardByStudent,
} from '../../redux/actions/materiaPeriodoActions';
import LoadingSpinner from '../../shared/components/LoadingSpinner';

import { createErrorMessage } from '../../helpers/notification';
import {
  dateDDMMYYFormat,
  dateDDMMYYHHMMFormat,
} from '../../helpers/dateFormat';
import {
  EstadoMateriaPeriodo,
} from '../../constants/enums';

class StudentsDashboardContainer extends PureComponent {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      items: [],
    };

    this.colors = [
      {
        value: 0, color: 'secondary',
      },
      {
        value: 1, color: 'info',
      },
      {
        value: 2, color: 'success',
      },
    ];
  }

  componentDidMount() {
    const { page, pageSize } = this.state;
    this.loadFormData(page, pageSize);
  }

  loadFormData = () => {
    AllSubjectsDashboardByStudent({
      onSuccess: (items) => {
        this.setState({
          loading: false,
          items,
        });
      },
      onError: () => {
        this.setState({ items: [], loading: false });
        createErrorMessage('Error al intentar cargar la lista de materias');
      },
    });
  }

  verMateria = (id) => {
    const { history } = this.props;
    history.push(`/pages/student-subjects/${id}`);
  };

  onDataTableClearFilters = () => {
    const { pageSize } = this.state;
    this.loadFormData(1, pageSize, {});
  };

  getGridActions = (key) => {
    const actions = {
      actions: this.actions,
    };
    return actions[key];
  }

  handleSubmitCard = (e) => {
    e.preventDefault();
  }

  getColor = ({ value }) => {
    const item = this.colors.find(c => c.value === value);
    if (!item) {
      return this.colors[0].color;
    }

    return item.color;
  };

  showEstadoMateriaPeriodoData = ({ estado, rendimientoAlumno }) => {
    if (![EstadoMateriaPeriodo.Publicado.value, EstadoMateriaPeriodo.Sellado.value].includes(estado.value)) {
      return null;
    }

    return (
      <Row dir="ltr" className="summary-card__item">
        <Col md={12}>
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'space-between',
              gap: '1rem',
            }}
          >
            <div>
              <span>{EstadoMateriaPeriodo.Publicado.label}: </span>
              <Badge
                style={{ fontSize: '0.81rem', paddingTop: '0.45rem' }}
                color={this.getColor(estado)}
                pill
              >
                {rendimientoAlumno ? dateDDMMYYHHMMFormat(rendimientoAlumno.fechaPublicado) : null}
              </Badge>
            </div>
            {
              EstadoMateriaPeriodo.Sellado.value === estado.value
                ? (
                  <div>
                    <span>{EstadoMateriaPeriodo.Sellado.label}: </span>
                    <Badge
                      style={{ fontSize: '0.81rem', paddingTop: '0.45rem' }}
                      color={this.getColor(estado)}
                      pill
                    >
                      {rendimientoAlumno ? dateDDMMYYHHMMFormat(rendimientoAlumno.fechaSellado) : null}
                    </Badge>
                  </div>
                )
                : null
            }
            <div>
              <span>Fecha Expiración: </span>
              <Badge
                style={{ fontSize: '0.81rem', paddingTop: '0.45rem' }}
                color={this.getColor(estado)}
                pill
              >
                {rendimientoAlumno ? dateDDMMYYFormat(rendimientoAlumno.fechaExpiracion) : null}
              </Badge>
            </div>
          </div>
        </Col>
      </Row>
    );
  };

  render() {
    const {
      loading,
      items,
    } = this.state;

    if (loading) {
      return (
        <LoadingSpinner />
      );
    }

    return (
      <Container>
        <Row>
          <Col md={12} className="text-center">
            {(!items || !items.length) && (
              <h4>
                <Alert color="info" className="text-center" icon="true">
                  <div>
                    No tienes materias marcadas para ver en el Tablero.
                  </div>
                  <div>
                    Puedes marcar las estrellas{' '}
                    <span className="fa fa-star fa-lg" />
                    {
                      ' en tu listado de "Mis Materias" para mostrarlas en el Tablero.'
                    }
                  </div>
                </Alert>
              </h4>
            )
            }
            {items && items.length && (
              <Card>
                <CardBody>
                  <Form className="form">
                    <div>
                      <h3 className="page-title" style={{ marginBottom: '0' }}>
                        Tablero{' / Lista de materias favoritas '}
                        <span className="fa fa-star" />
                      </h3>
                    </div>

                    <Container className="summary-container">
                      <Row dir="ltr" style={{ marginBottom: '1rem' }}>
                        <Col sm={12}>
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
                            <h4 style={{ textAlign: 'end' }}>Estados:</h4>
                            <Badge
                              style={{ fontSize: '0.81rem', paddingTop: '0.45rem' }}
                              color="secondary"
                              pill
                            >
                              Preliminar
                            </Badge>
                            <Badge
                              style={{ fontSize: '0.81rem', paddingTop: '0.45rem' }}
                              color="info"
                              pill
                            >
                              Publicado
                            </Badge>
                            <Badge
                              style={{ fontSize: '0.81rem', paddingTop: '0.45rem' }}
                              color="success"
                              pill
                            >
                              Sellado
                            </Badge>
                          </div>
                        </Col>
                      </Row>
                      <Row dir="ltr">
                        {items.map(g => (
                          <Col
                            className="pb-4"
                            sm={12}
                            md={6}
                            lg={4}
                            xl={3}
                            key={`subject_${g.id}`}
                          >
                            <div style={{ display: 'grid' }}>
                              <Card
                                outline
                                color="primary"
                                onClick={() => this.verMateria(g.id)}
                                className="link-card card-subject pb-0"
                              >
                                <CardBody className={`summary-card summary-card--${this.getColor(g.estado)}`}>
                                  <h5
                                    className="summary-card__title"
                                    style={{
                                      display: 'inline-flex',
                                      flexWrap: 'wrap',
                                      alignItems: 'flex-end',
                                      justifyContent: 'space-between',
                                      gap: '0.5rem',
                                      width: '100%',
                                      marginBottom: '0',
                                    }}
                                  >
                                    <Badge
                                      style={{ fontSize: '0.81rem' }}
                                      color={this.getColor(g.estado)}
                                      pill
                                    >
                                      {g.seccion}
                                    </Badge>
                                    <Badge
                                      style={{ fontSize: '0.81rem' }}
                                      color={this.getColor(g.estado)}
                                      pill
                                    >
                                      # {g.id}
                                    </Badge>
                                    {' '}
                                    <Badge
                                      style={{ fontSize: '0.81rem' }}
                                      color={this.getColor(g.estado)}
                                      pill
                                    >
                                      Cod {g.codigoMateria}
                                    </Badge>
                                  </h5>
                                  <div className="summary-card__body checklist-card">
                                    <h4 className="summary-card__title" style={{ marginBottom: '0' }}>
                                      {g.materia}
                                    </h4>
                                    <em style={{ fontSize: '12px', color: 'slategray' }}>Periodo {g.periodo}</em>
                                    <hr />
                                    <Row dir="ltr" className="summary-card__item">
                                      <Col md={12}>
                                        <div
                                          style={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            justifyContent: 'space-between',
                                            gap: '1rem',
                                          }}
                                        >
                                          <span>
                                            {g.malla}
                                          </span>
                                          <span>
                                            {g.semestreNroOrden}{' º Semestre '}{g.anho}
                                          </span>
                                        </div>
                                      </Col>
                                    </Row>

                                    <Row dir="ltr" className="summary-card__item">
                                      <Col md={12}>
                                        <div
                                          style={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            justifyContent: 'space-between',
                                            gap: '1rem',
                                          }}
                                        >
                                          <div>
                                            <span>Asistencia: </span>
                                            <Badge
                                              color={this.getColor(g.estado)}
                                              pill
                                            >
                                              {Math.round(g.porcentajeAsistencia)} %
                                            </Badge>
                                          </div>
                                          <div>
                                            <span>PP: </span>
                                            <Badge
                                              color={this.getColor(g.estado)}
                                              pill
                                            >
                                              {Math.round(g.porcentajePP)} %
                                            </Badge>
                                          </div>
                                        </div>
                                      </Col>
                                    </Row>
                                    {this.showEstadoMateriaPeriodoData(g)}

                                  </div>
                                </CardBody>
                              </Card>
                            </div>
                          </Col>
                        ))
                        }
                      </Row>
                    </Container>
                  </Form>
                </CardBody>
              </Card>
            )
            }
          </Col>
        </Row>
      </Container>
    );
  }
}

export default withRouter(StudentsDashboardContainer);
